import { Prices, PricesToFetch } from 'store/price/types';

const mapPricesToPricesToFetch = (prices: Prices, encPublicDesignId = ''): PricesToFetch => {
  const pricesToFetch: PricesToFetch = {};
  Object.keys(prices).forEach((categoryId) => {
    pricesToFetch[categoryId] = {
      categoryId: Number(categoryId),
      productIds: Object.keys(prices[+categoryId]).map((productId) => Number(productId)),
      encryptedDesignId: encPublicDesignId || '',
    };
  });
  return pricesToFetch;
};

export default mapPricesToPricesToFetch;
